import React, { useRef, useEffect } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { VideoPlayerProps } from './types';

export function VideoPlayer({
  url,
  playing = false,
  controls = true,
  loop = false,
  width = '100%',
  height = '100%',
  onEnded,
}: VideoPlayerProps): React.ReactElement {
  const videoRef = useRef<HTMLDivElement>(null);
  const playerRef = useRef<any>(null);

  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement('video-js');
      videoElement.classList.add('vjs-big-play-centered');
      videoRef.current!.appendChild(videoElement);

      const player = playerRef.current = videojs(videoElement, {
        controls,
        autoplay: playing,
        preload: 'auto',
        fill: true,
        sources: [{
          src: url,
          type: 'application/x-mpegURL'
        }]
      });

      if (onEnded) {
        player.on('ended', onEnded);
      }
    }

    return () => {
      if (playerRef.current && !playerRef.current.isDisposed()) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [url]);

  return <div ref={videoRef} style={{ width: '100%', height: '100%' }} />;
}
